//
// Module for Benefit Estimate factors tab
//
rs.module("ui/controls/content/benefitestimatetabs/factors",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, ajaxUrls) {

            var factorsTab = $.js(jsSelectors.factorsTab);

            var benefitEstimateKeyInput = factorsTab.js(jsSelectors.benefitEstimateKeyInput);

            var factorsFilter = factorsTab.js(jsSelectors.factorsFilter);
            var planSelect = factorsFilter.js(jsSelectors.planSelect);
            var loadingSpinner = factorsFilter.js(jsSelectors.loadingSpinner);

            planSelect.change(updateCalculationFactorsGrid);

            // Update the calculation factors for the provided plan
            function updateCalculationFactorsGrid() {
                loadingSpinner.show();

                gridModule.update(
                    ajaxUrls.getCalculationFactorsGridData,
                    {
                        benefitEstimateKey: benefitEstimateKeyInput.val(),
                        organizationReferenceNumber: planSelect.val()
                    },
                    lrsGridApi.agGridApi,
                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    });